import styled from '@emotion/styled';
import { Variables } from '../base/variables/variables';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    width: 100%;
`;

export const LoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    max-width: 500px;
`;

export const ErrorMessage = styled.div`
    font-size: ${Variables.FontSizes.large};
    color: ${Variables.Colors.warning};
    text-align: center;
    margin-bottom: 16px;
`;
